import React from 'react';
import classes from './Burger.css';
import BurgerIngredient from './BurgerIngredient/BurgerIngredient';

const burger = (props) =>
{
    // at the end, transformedIngredients will be an array of arrays. with the inner(smaller) arrays containing the JSX
    let transformedIngredients = Object.keys(props.ingredients) // transforms object of key value pairs into an array of ingredients. SO if bacon had x2, there would be [bacon,bacon]
    .map(igKey =>{ // at this point, we have passed in an array of the ingredients as igKey ( but each one will be iterated over individually)
        console.log("the igKey:" + igKey + " " + props.ingredients[igKey]);
        return [...Array(props.ingredients[igKey])].map((_, index) => // props.ingredients[igKey] is the total amount of each ingredient(ex- meat: 2)
        {
            // so ...Array(props.ingredients[igKey]) will create an array with a size for the total amount of that ingredient)
            // then we are adding to our total array [...] as JSX elements. (we create a smaller array to add to our bigger array)
            // so if an ingredient cheese has 2 as its value. our smaller array size will be 2, then we will add cheese twice to the array
            // then we get a unique id, because you have the unique ingredient name + its location in the array. 'cheese0', 'cheese1' 
            //console.log("")
            //console.log(igKey + index)
            return <BurgerIngredient key = {igKey + index} type = {igKey} /> // returns a JSX element to be stored in smaller array
            // then lastly, the smaller array gets stored in the bigger array, and iterates to the next ingredient
        });
    } ) 
    // makes it a single array rather than array within array
    .reduce((arr, el) => { // arr being previous value, and el is the new value
        // loops through all the values 
        return arr.concat(el) // combines the info from the inner arrays to the outer arrays
    }, []); // [] is the initial value of the reduced value

// in the case of an empty hamburger:
if (transformedIngredients.length === 0)
{
    transformedIngredients = <p>Please Start adding ingredients</p>
}

    return(
        <div className = {classes.Burger}>
            <BurgerIngredient type = "bread-top"/>
            {transformedIngredients}
            <BurgerIngredient type = "bread-bottom"/>
        </div>
    );
};

export default burger;


// WEBPACK FOOTER //
// ./src/components/Burger/Burger.js